import { Pipe, PipeTransform } from '@angular/core';
import { getInitials, getName, User } from '@marmon/shared/types/user';

@Pipe({
	name: 'userInitials',
	standalone: true,
})
export class UserInitialsPipe implements PipeTransform {
	transform(value: User) {
		const name = getName(value);
		return getInitials(name);
	}
}
